import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { TechnologiesManagementService } from '../../shared/services/technologiesManagement.service';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';

@Component({
  standalone: false,
  selector: 'app-manage-techs-dialog',
  templateUrl: './manage-techs-dialog.component.html',
  styleUrls: ['./manage-techs-dialog.component.css']
})
export class ManageTechsDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  formGroup!: FormGroup;
  isEdit: boolean = false;
  invalidInput: boolean = false;

  errorMessages: any;

  constructor(
    public dialogRef: MatDialogRef<ManageTechsDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService,
    private techsService: TechnologiesManagementService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.isEdit = this.local_data.edit;

    if (this.isEdit) {
      this.formGroup = this._formBuilder.group({
        nameCtrl: [this.local_data.tecName, Validators.required],
        techActiveCtrl: [this.local_data.tecActive, Validators.required],
      });
    }
    else {
      this.formGroup = this._formBuilder.group({
        nameCtrl: [this.local_data.tecName, Validators.required],
        techActiveCtrl: ["true", Validators.required],
      });
    }

    this.errorMessages = {
      "Only SUPER-ADMIN or ADMIN can add a technology.": this.variables.onlySUPERADMINandADMINCanAddTech,
      "Technology name is required.": this.variables.TechNameRequired,
      "A technology with this name already exists.": this.variables.TechAlreadyExists,
      "Access denied.": this.variables.notAuthorized,
      "Technology not found": this.variables.technology + this.variables.notFound,
      "Cannot edit technology that exists in the catalog": this.variables.cannotEditExistingTechnology,
      "Technology name is required": this.variables.technologyNameRequired,
      "Active status must be true or false": this.variables.activeStatusTrueOrFalse,
      "A technology with this name already exists": this.variables.technologyNameAlreadyExists,
      'Invalid JWT token': this.variables.sessionExpired,
    };

  }

  doAction() {
    if (this.formGroup.valid) {
      if (!this.local_data.edit) {
        this.techsService.addNewTechnology(this.formGroup.value.nameCtrl).subscribe
          ({
            next: (data) => {

              if (data) {
                this.dialogRef.close({ data: { success: true, newTech: this.formGroup.value.nameCtrl } });
              }
            },
            error: (error) => {
              console.error('Error:', error.error);

              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);


            }
          })
      }
      else {
        this.techsService.editTechnology(this.local_data.tecId, this.formGroup.value.nameCtrl, this.formGroup.value.techActiveCtrl).subscribe
          ({
            next: (data) => {

              if (data) {
                this.dialogRef.close({ data: { success: true } });
              }
            },
            error: (error) => {
              console.error('Error:', error.error);

              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);


            }
          })
      }

    }
  }


}
